import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Loader2 } from 'lucide-react';

// Lightweight destructive confirmation modal — replaces window.confirm across
// the admin area so deletes show a proper UI and don't block on mobile.
export default function ConfirmDialog({
  open, title = 'Confirm', description, confirmLabel = 'Delete',
  onConfirm, onClose, busy,
}) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="bg-[#111115] border border-white/10 max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-white font-black uppercase flex items-center gap-2">
            <AlertTriangle className="w-4 h-4 text-red-400" /> {title}
          </DialogTitle>
        </DialogHeader>
        {description && <p className="text-white/50 text-sm">{description}</p>}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button variant="destructive" onClick={onConfirm} disabled={busy}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}